var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col order-1 order-lg-2" }, [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-6 offset-md-3 bg-light p-5" }, [
        _c("h1", { staticClass: "h4 text-center" }, [
          _vm._v(_vm._s(_vm._f("translate")("Log in"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputEmail" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Email")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "email",
                id: "inputEmail",
                required: "",
                autofocus: "",
              },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", { attrs: { name: "email", errors: _vm.errors } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", { attrs: { for: "inputPassword" } }, [
              _c("small", [_vm._v(_vm._s(_vm._f("translate")("Password")))]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "password", id: "inputPassword", required: "" },
              domProps: { value: _vm.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("InputErrors", {
              attrs: { name: "password", errors: _vm.errors },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3 my-4 text-center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.login.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")("Sign in")) +
                  "\n        "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center mt-3" }, [
          _c("small", [
            _c("a", { attrs: { href: "/password/reset" } }, [
              _vm._v(_vm._s(_vm._f("translate")("Forgot Your Password?"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center mt-3" }, [
          _c(
            "small",
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")("No account yet?")) +
                  "\n          "
              ),
              !_vm.isAuthenticated
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to: `/${_vm.$route.params.course}/watch/register`,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("translate")("Sign up now")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }